import React, { useRef, useState } from "react";

function FileUploader({ btn_text = "Browse", label = "Upload file" }) {
  const [fileName, setFileName] = useState(""); // To store the file name
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFileName(selectedFile.name); // Set the file name in state
    }
  };

  const handleButtonClick = () => {
    fileInputRef.current.click(); // Open file picker
  };

  return (
    <div className="file">
      <label htmlFor="fileInput" className="file-label">
        {label}
      </label>
      <div className="uploader-area">
        <input
          type="text"
          value={fileName}
          placeholder="No file chosen"
          readOnly
          className="file-name-input"
        />
        <button
          type="button"
          onClick={handleButtonClick}
          className="btn"
        >
          {btn_text}
        </button>
        <input
          id="fileInput"
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
}

export default FileUploader;
